module.exports = __webpack_public_path__ + "img/3.17542981.png";